// A date filter trigger and panel: Is, Is before, Is after or Is between, committed as soon as a date is
// complete. Calendar dates compare without any timezone conversion.

import React from 'react'
import PropTypes from 'prop-types'

import { FilterMenu } from './FilterMenu'
import { RangeEditor } from './RangeEditor'

export const DateFilter = ({ column }) => (
  <FilterMenu column={column}>
    <RangeEditor column={column} type="date" />
  </FilterMenu>
)

DateFilter.propTypes = {
  column: PropTypes.object.isRequired,
}
